import * as React from "react";
import { QAPropsBase } from "../State";
import CheckboxAnswer from "./CheckboxAnswer";
import DropDownAnswer from "./DropDownAnswer";
import InputAnswer from "./InputAnswer";
import Question from "../components/Question";
import RadioAnswer from "./RadioAnswer";
import TextAreaAnswer from "./TextAreaAnswer";
import { changeFn } from "../store";
import FileAnswer from "./FileAnswer";
import ConditionalFileAnswer from "./ConditionalFileAnswer";
import PCovTableAnswer from "./PCovTableAnswer";
import OwnershipTableAnswer from "./OwnershipTableAnswer";
import DatesAnswer from "./DatesAnswer";
import NamesAndLocationsAnswer from "./NamesAndLocationsAnswer";

// tslint:disable-next-line: interface-name
export interface QAProps {
    propsBase: QAPropsBase;
    index: number;
    onChange?: changeFn;
}

const QuestionAnswer: React.FunctionComponent<QAProps> = (props: QAProps) => {
    return (
        <div id={"question" + props.index} style={{marginTop: "30px"}}>
        <Question questionContent={props.propsBase.questionContent}
                id={props.index} isRequired={props.propsBase.isRequired} />
        {
          props.propsBase.isRequired && <span className="required"></span>
        }
        {
            // tslint:disable-next-line: max-line-length
            ((props.propsBase.answerType === "text" &&
                    <InputAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "tel" &&
                    <InputAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "number" &&
                    <InputAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "email" &&
                    <InputAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "date" &&
                    <InputAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "file" &&
                    <FileAnswer index={props.index} propsBase={props.propsBase}/>) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "conditional-file" &&
                    <ConditionalFileAnswer index={props.index} propsBase={props.propsBase}/>) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "ownership-table" &&
                    <OwnershipTableAnswer index={props.index} propsBase={props.propsBase} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "date-table" &&
                    <DatesAnswer index={props.index} propsBase={props.propsBase} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "names-locations-table" &&
                    <NamesAndLocationsAnswer index={props.index} propsBase={props.propsBase} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "pcov-table" &&
                    <PCovTableAnswer index={props.index} propsBase={props.propsBase} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "pcov-table-ex" &&
                <PCovTableAnswer byCarrier={true} index={props.index} propsBase={props.propsBase} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "TextArea" &&
                    <TextAreaAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "Radio" &&
                    <RadioAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                (props.propsBase.answerType === "Checkbox" &&
                    <CheckboxAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />) ||
                // tslint:disable-next-line: max-line-length
                    (props.propsBase.answerType === "DropDown" &&
                        <DropDownAnswer index={props.index} propsBase={props.propsBase} onChange={props.onChange} />))
        }
      </div>
    );
  };

export default QuestionAnswer;
